import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ISelectOption } from 'types';

import { IForwardShorten, IGoCertificateShorten } from 'modules/eecs-go';

import { CommonFilters, EnergyTypesResponse } from '../types/eecs-common.types';

interface EecsCommonInitialState {
  selectedCertificates: Map<string, IGoCertificateShorten>;
  selectedForwards: Map<string, IForwardShorten>;
  energyTypes: EnergyTypesResponse | null;
  techCodes: ISelectOption[];
  energyCodes: ISelectOption[];
  lockFilters: CommonFilters | null;
}

const eecsCommonInitialState: EecsCommonInitialState = {
  selectedCertificates: new Map(),
  selectedForwards: new Map(),
  energyTypes: null,
  lockFilters: null,
  techCodes: [],
  energyCodes: [],
};

export const eecsCommon = createSlice({
  name: 'eecsCommon',
  initialState: eecsCommonInitialState,
  reducers: {
    setCommonSelectedCertificates: (state, action: PayloadAction<Map<string, IGoCertificateShorten>>) => {
      state.selectedCertificates = action.payload;
    },
    setCommonSelectedForwards: (state, action: PayloadAction<Map<string, IForwardShorten>>) => {
      state.selectedForwards = action.payload;
    },
    setCommonTechCodes: (state, action: PayloadAction<ISelectOption[]>) => {
      state.techCodes = action.payload;
    },
    setCommonEnergyCodes: (state, action: PayloadAction<ISelectOption[]>) => {
      state.energyCodes = action.payload;
    },
    setCommonEnergyTypes: (state, action: PayloadAction<EnergyTypesResponse | null>) => {
      state.energyTypes = action.payload;
    },
    setCommonLockFilters: (state, action: PayloadAction<CommonFilters | null>) => {
      state.lockFilters = action.payload;
    },
  },
});

export const {
  setCommonSelectedCertificates,
  setCommonSelectedForwards,
  setCommonTechCodes,
  setCommonEnergyCodes,
  setCommonEnergyTypes,
  setCommonLockFilters,
} = eecsCommon.actions;
